import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { MoveToParentCommand } from './move-to-parent.command';
import { MoveToParentResult } from './move-to-parent.result';

/**
 * Move to parent use case.
 * Reassigns a child case to a different parent case.
 * This unlinks from the current parent and sets a new one.
 */
@Injectable({ providedIn: 'root' })
export class MoveToParentUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(command: MoveToParentCommand): Observable<MoveToParentResult> {
    this._state.setErrorParentChildCases(null);

    return this._repository.setParentCase(command.caseId, command.newParentCaseId).pipe(
      tap(() => {
        // Caller is responsible for reloading state after success
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setErrorParentChildCases(error.message || 'Failed to move to new parent case');
        return throwError(() => error);
      })
    );
  }
}
